var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',_vm._g({attrs:{"label":_vm.label,"error-messages":_vm.errors,"input-value":_vm.value,"inset":""}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }